import React, { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";

import classnames from "classnames";

import { NavHashLink } from "react-router-hash-link";

import PageTitle from "../components/utility";
import FanFactTwo from "../components/FuncFact/FanFactTwo";

import "../assets/demo/css/demo.css";

function PreviewPage() {
  const [scroll, setScroll] = useState(false);

  const [headerHeight, setHeaderHeight] = useState(false);

  useEffect(() => {
    const Header = document.getElementById("header-section");
    setHeaderHeight(Header.offsetHeight);
    window.addEventListener("scroll", handleScroll);
  }, []);

  const handleScroll = () => {
    setScroll(window.scrollY);
  };

  const [activeTab, setActiveTab] = useState("1");

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <Fragment>
      <div id="page-top">
        <PageTitle
          PageTitle="Appal - Demo Page"
          favicon={
            process.env.PUBLIC_URL + "/assets/demo/images/favourite-icon-1.png"
          }
        />

        <header
          id="header-section"
          className={`header-section sticky-header ${
            scroll > headerHeight ? "stuck" : "not-stuck"
          }`}
        >
          <div className="container">
            <div className="row">
              {/* <!-- main-menubar - start --> */}
              <div className="col-lg-8 col-sm-6 col-12">
                <nav className="main-menubar" id="previwnavbar">
                  <ul className="text-center text-md-left">
                    <li>
                      <NavHashLink
                        className="nav-link"
                        activeClassName="active"
                        to="/#page-top"
                        smooth={true}
                        offset={-70}
                        duration={500}
                      >
                        Home
                      </NavHashLink>
                    </li>
                    <li>
                      <NavHashLink
                        className="nav-link"
                        to="/#preview-section"
                        activeClassName="active"
                        smooth={true}
                        offset={-70}
                        duration={500}
                      >
                        pages
                      </NavHashLink>
                    </li>
                    <li>
                      <NavHashLink
                        className="nav-link"
                        to="/#feature-section"
                        activeClassName="active"
                        smooth={true}
                        offset={-70}
                        duration={500}
                      >
                        Features
                      </NavHashLink>
                    </li>
                  </ul>
                </nav>
              </div>
              {/* <!-- main-menubar - end -->

					<!-- btns-group - start --> */}
              <div className="col-lg-4 col-sm-6 col-12">
                <div className="btns-group text-center text-md-right mt-3 mt-sm-0">
                  <a
                    href="https://themeforest.net/user/marvel_theme"
                    target={"_blank"}
                    rel="noopener noreferrer"
                    className="download-btn"
                  >
                    download appal
                  </a>
                </div>
              </div>
              {/* <!-- btns-group - end --> */}
            </div>
          </div>
        </header>
        {/* <!-- header-section - end
		================================================== -->





		<!-- banner-section - start
		================================================== --> */}
        <section
          id="banner-section"
          className="banner-section clearfix"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/assets/demo/images/banner-bg-2.png)`,
          }}
        >
          <div className="overlay-black">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-12">
                  <div className="banner-content text-center">
                    <div className="brand-logo mb-60">
                      <Link to="#!" className="brand-link">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/logo-3.png"
                          }
                          alt="image_not_found"
                        />
                      </Link>
                    </div>

                    <h1 className="big-title">
                      Appal - Multipurpose React Js Landing Page Template
                    </h1>
                    <h3 className="sub-title">
                      Specially designed for Mobile app, App Store, Technology
                      Startup, Saas & Software
                    </h3>

                    <div className="counter-section mb-60">
                      <FanFactTwo />
                    </div>
                    <p className="paragraph-text mb-0">
                      appal is specially designed for Mobile app, App Store,
                      Startup, Saas & Software.
                      <span>
                        12+ Home page Variations, with 19+ Essential Pages, Easy
                        to Setup, Conversion focused &
                      </span>
                      Faster in Loading with better User Experience.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <!-- banner-section - end
		================================================== -->





		<!-- preview-section - start
		================================================== --> */}
        <section
          id="preview-section"
          className="preview-section sec-ptb-160 pb-0 clearfix"
        >
          <div className="container">
            <div className="section-title mb-60 text-center">
              <h2 className="title-text">Check out our all Demos</h2>
            </div>

            <div className="preview-tab-nav">
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "1" })}
                    onClick={() => {
                      toggle("1");
                    }}
                  >
                    all demos
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "2" })}
                    onClick={() => {
                      toggle("2");
                    }}
                  >
                    mobile app
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "3" })}
                    onClick={() => {
                      toggle("3");
                    }}
                  >
                    saas/software
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "4" })}
                    onClick={() => {
                      toggle("4");
                    }}
                  >
                    app store
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "5" })}
                    onClick={() => {
                      toggle("5");
                    }}
                  >
                    blog pages
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "6" })}
                    onClick={() => {
                      toggle("6");
                    }}
                  >
                    inner pages
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "7" })}
                    onClick={() => {
                      toggle("7");
                    }}
                  >
                    others page
                  </NavLink>
                </NavItem>
              </Nav>
            </div>

            <TabContent activeTab={activeTab}>
              <TabPane tabId="1">
                <div className="row justify-content-center">
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/01-appal-mobile-app1.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="app-landing-creative"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="app-landing-creative"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">App Landing Creative</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/02-appal-sass-landing-page1.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="saas-landing-creative"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="saas-landing-creative"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">Saas Landing Creative</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/03-app-store1.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="app-store-creative"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="app-store-creative"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">App Store Creative</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/01-appal-mobile-app2.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="app-landing-elegant"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="app-landing-elegant"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">App Landing Elegant</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/02-appal-sass-landing-page2.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="saas-landing-elegant"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="saas-landing-elegant"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">Saas Landing Elegant</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/03-app-store2.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="app-store-elegant"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="app-store-elegant"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">App Store Elegant</h3>
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="row justify-content-center">
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/01-appal-mobile-app3.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="app-landing-modern"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="app-landing-modern"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">App Landing Modern</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/02-appal-sass-landing-page3.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="saas-landing-exclusive"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="saas-landing-exclusive"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">Saas Landing Exclusive</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/01-appal-mobile-app4.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="app-landing-minimal"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="app-landing-minimal"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">App Landing Minimal</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/01-appal-mobile-app5.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="app-landing-exclusive"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="app-landing-exclusive"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">App Landing Exclusive</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/02-appal-sass-landing-page4.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="saas-landing-modern"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="saas-landing-modern"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">Saas Landing Modern</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/01-appal-mobile-app6.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="app-landing-classic"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="app-landing-classic"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">App Landing classic</h3>
                      </Link>
                    </div>
                  </div>
                </div>

                <hr />

                <div className="row justify-content-center">
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/03-single-app3.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="app-details-v1"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="app-details-v1"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">App Details v.1</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/03-single-app4.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="app-details-v2"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="app-details-v2"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">App Details v.2</h3>
                      </Link>
                    </div>
                  </div>
                </div>

                <hr />

                <div className="row justify-content-center">
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/10-blog-post1-default.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="blog-default-page"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="blog-default-page"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">Blog Post - Default</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/10-blog-post2-standard.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="blog-standard-page"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="blog-standard-page"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">Blog Post - Standard</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/10-blog-post3-2column.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="blog-two-column-page"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="blog-two-column-page"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">Blog Post - 2 Column</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/10-blog-post4-3column.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="blog-three-column-page"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="blog-three-column-page"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">Blog Post - 3 Column</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/11-blog-details1-default.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="blog-details-one-page"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="blog-details-one-page"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">Blog Details - Default</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/11-blog-details2-right-sidebar.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="blog-details-two-page"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="blog-details-two-page"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">
                          Blog Details - Right Sidebar
                        </h3>
                      </Link>
                    </div>
                  </div>
                </div>

                <hr />

                <div className="row justify-content-center">
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/04-about-us.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="about-us"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="about-us"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">About Us</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/18-features-app.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="features-app-landing-creative"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="features-app-landing-creative"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">App Feature</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/19-features-sass.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="features-saas-landing-creative"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="features-saas-landing-creative"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">Sass Feature</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/05-Pricing-table-page.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="pricing-page"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="pricing-page"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">Pricing Plan</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/06-product-reviews-page.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="review-page"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="review-page"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">Customar Reviews</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/07-team-member-page.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="team"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link to="team" target="_blank" className="header-link">
                        <h3 className="title-text">Our Team</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/08-faq's-page.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="faq"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link to="faq" target="_blank" className="header-link">
                        <h3 className="title-text">
                          Frequently Asked Questions
                        </h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/09-contact_page.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="contact-us"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="contact-us"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">Contact With Us</h3>
                      </Link>
                    </div>
                  </div>
                </div>

                <hr />

                <div className="row justify-content-center">
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item small-preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/13-404_page.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="404"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link to="404" target="_blank" className="header-link">
                        <h3 className="title-text">404 Page</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item small-preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/14-coming-soon-page.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="coming-soon"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="coming-soon"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">Coming Soon</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item small-preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/15-rerister-page.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="register"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="register"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">Rerister Page</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item small-preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/16-login-page.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="login"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link to="login" target="_blank" className="header-link">
                        <h3 className="title-text">Login Page</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item small-preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/17-forgot-password-page.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="forget-password"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="forget-password"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">Forgot Password</h3>
                      </Link>
                    </div>
                  </div>
                </div>
              </TabPane>

              <TabPane tabId="2">
                <div className="row justify-content-center">
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/01-appal-mobile-app1.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="app-landing-creative"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="app-landing-creative"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">App Landing Creative</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/01-appal-mobile-app2.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="app-store-elegant"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="app-landing-elegant"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">App Landing Elegant</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/01-appal-mobile-app3.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="app-landing-modern"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="app-landing-modern"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">App Landing Modern</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/01-appal-mobile-app4.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="app-landing-minimal"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="app-landing-minimal"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">App Landing Minimal</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/01-appal-mobile-app5.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="app-landing-exclusive"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="app-landing-exclusive"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">App Landing Exclusive</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/01-appal-mobile-app6.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="app-landing-classic"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="app-landing-classic"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">App Landing classic</h3>
                      </Link>
                    </div>
                  </div>
                </div>
              </TabPane>

              <TabPane tabId="3">
                <div className="row justify-content-center">
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/02-appal-sass-landing-page1.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="saas-landing-creative"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="saas-landing-creative"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">Saas Landing Creative</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/02-appal-sass-landing-page2.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="saas-landing-elegant"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="saas-landing-elegant"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">Saas Landing Elegant</h3>
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="row justify-content-center">
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/02-appal-sass-landing-page3.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="saas-landing-modern"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="saas-landing-modern"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">Saas Landing Modern</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/02-appal-sass-landing-page4.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="saas-landing-exclusive"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="saas-landing-exclusive"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">Saas Landing Exclusive</h3>
                      </Link>
                    </div>
                  </div>
                </div>
              </TabPane>

              <TabPane tabId="4">
                <div className="row justify-content-center">
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/03-app-store1.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="app-store-creative"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="app-store-creative"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">App Store Creative</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/03-app-store2.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="app-store-classic"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="app-store-classic"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">App Store classic</h3>
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="row justify-content-center">
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/03-single-app3.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="app-details-v1"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="app-details-v1"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">App Details v.1</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/03-single-app4.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="app-details-v2"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="app-details-v2"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">App Details v.2</h3>
                      </Link>
                    </div>
                  </div>
                </div>
              </TabPane>

              <TabPane tabId="5">
                <div className="row justify-content-center">
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/10-blog-post1-default.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="blog-default-page"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="blog-default-page"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">Blog Post - Default</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/10-blog-post2-standard.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="blog-standard-page"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="blog-standard-page"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">Blog Post - Standard</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/10-blog-post3-2column.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="blog-two-column-page"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="blog-two-column-page"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">Blog Post - 2 Column</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/10-blog-post4-3column.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="blog-three-column-page"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="blog-three-column-page"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">Blog Post - 3 Column</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/11-blog-details1-default.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="blog-details-one-page"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="blog-details-one-page"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">Blog Details - Default</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/11-blog-details2-right-sidebar.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="blog-details-two-page"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="blog-details-two-page"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">
                          Blog Details - Right Sidebar
                        </h3>
                      </Link>
                    </div>
                  </div>
                </div>
              </TabPane>

              <TabPane tabId="6">
                <div className="row justify-content-center">
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/04-about-us.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="about-us"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="about-us"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">About Us</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/05-Pricing-table-page.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="pricing-page"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="pricing-page"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">Pricing Plan</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/06-product-reviews-page.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="review-page"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="review-page"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">Customar Reviews</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/07-team-member-page.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="team"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link to="team" target="_blank" className="header-link">
                        <h3 className="title-text">Our Team</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/08-faq's-page.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="faq"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link to="faq" target="_blank" className="header-link">
                        <h3 className="title-text">
                          Frequently Asked Questions
                        </h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/09-contact_page.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="contact-us"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="contact-us"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">Contact With Us</h3>
                      </Link>
                    </div>
                  </div>
                </div>
              </TabPane>

              <TabPane tabId="7">
                <div className="row justify-content-center">
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item small-preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/13-404_page.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="404"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link to="404" target="_blank" className="header-link">
                        <h3 className="title-text">404 Page</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item small-preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/14-coming-soon-page.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="coming-soon"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="coming-soon"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">Coming Soon</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item small-preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/15-rerister-page.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="register"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="register"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">Rerister Page</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item small-preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/16-login-page.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="login"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link to="login" target="_blank" className="header-link">
                        <h3 className="title-text">Login Page</h3>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="preview-item small-preview-item text-center">
                      <div className="image-container">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/demo/images/preview/17-forgot-password-page.jpg"
                          }
                          alt="image_not_found"
                        />
                        <Link
                          to="forget-password"
                          target="_blank"
                          className="plus-effect"
                        ></Link>
                      </div>
                      <Link
                        to="forget-password"
                        target="_blank"
                        className="header-link"
                      >
                        <h3 className="title-text">Forgot Password</h3>
                      </Link>
                    </div>
                  </div>
                </div>
              </TabPane>
            </TabContent>
          </div>
        </section>
        {/* <!-- preview-section - end
		================================================== --> */}

        {/* <!-- feature-section - start
		================================================== --> */}
        <section
          id="feature-section"
          className="feature-section sec-ptb-160 clearfix"
        >
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="section-title">
                  <h2 className="title-text">template features</h2>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="features-item">
                  <div className="image-container">
                    <span>
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/demo/images/preview/features/html5.png"
                        }
                        alt="image_not_found"
                      />
                    </span>
                  </div>
                  <h3 className="title-text">html5</h3>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="features-item">
                  <div className="image-container">
                    <span>
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/demo/images/preview/features/css3.png"
                        }
                        alt="image_not_found"
                      />
                    </span>
                  </div>
                  <h3 className="title-text">css3</h3>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="features-item">
                  <div className="image-container">
                    <span>
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/demo/images/preview/features/sass.png"
                        }
                        alt="image_not_found"
                      />
                    </span>
                  </div>
                  <h3 className="title-text">scss</h3>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="features-item">
                  <div className="image-container">
                    <span>
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/demo/images/preview/features/bootstrap.png"
                        }
                        alt="image_not_found"
                      />
                    </span>
                  </div>
                  <h3 className="title-text">reactstrap 4</h3>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="features-item">
                  <div className="image-container">
                    <span>
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/demo/images/preview/features/google-font.png"
                        }
                        alt="image_not_found"
                      />
                    </span>
                  </div>
                  <h3 className="title-text">free google font</h3>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="features-item">
                  <div className="image-container">
                    <span>
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/demo/images/preview/features/fontawesome.png"
                        }
                        alt="image_not_found"
                      />
                    </span>
                  </div>
                  <h3 className="title-text">fontawesome icons</h3>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="features-item">
                  <div className="image-container">
                    <span>
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/demo/images/preview/features/flaticon.png"
                        }
                        alt="image_not_found"
                      />
                    </span>
                  </div>
                  <h3 className="title-text">flaticon</h3>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="features-item">
                  <div className="image-container">
                    <span>
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/demo/images/preview/features/unicons.png"
                        }
                        alt="image_not_found"
                      />
                    </span>
                  </div>
                  <h3 className="title-text">unicons</h3>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="features-item">
                  <div className="image-container">
                    <span>
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/demo/images/preview/features/react-modal.jpg"
                        }
                        alt="image_not_found"
                      />
                    </span>
                  </div>
                  <h3 className="title-text">react modal video</h3>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="features-item">
                  <div className="image-container">
                    <span>
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/demo/images/preview/features/w3c-validation.png"
                        }
                        alt="image_not_found"
                      />
                    </span>
                  </div>
                  <h3 className="title-text">w3c validation</h3>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="features-item">
                  <div className="image-container">
                    <span>
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/demo/images/preview/features/react-swiper.png"
                        }
                        alt="image_not_found"
                      />
                    </span>
                  </div>
                  <h3 className="title-text">swiper slider</h3>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="features-item">
                  <div className="image-container">
                    <span>
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/demo/images/preview/features/aos.png"
                        }
                        alt="image_not_found"
                      />
                    </span>
                  </div>
                  <h3 className="title-text">AOS scroll animation</h3>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="features-item">
                  <div className="image-container">
                    <span>
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/demo/images/preview/features/parallax.png"
                        }
                        alt="image_not_found"
                      />
                    </span>
                  </div>
                  <h3 className="title-text">React parallax</h3>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="features-item">
                  <div className="image-container">
                    <span>
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/demo/images/preview/features/code.png"
                        }
                        alt="image_not_found"
                      />
                    </span>
                  </div>
                  <h3 className="title-text">clear code</h3>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="features-item">
                  <div className="image-container">
                    <span>
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/demo/images/preview/features/document.png"
                        }
                        alt="image_not_found"
                      />
                    </span>
                  </div>
                  <h3 className="title-text">well documented</h3>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="features-item">
                  <div className="image-container">
                    <span>
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/demo/images/preview/features/customize.png"
                        }
                        alt="image_not_found"
                      />
                    </span>
                  </div>
                  <h3 className="title-text">easy to customize</h3>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <!-- feature-section - end
		================================================== --> */}

        {/* 
		<!-- footer-section - start
		================================================== --> */}
        <footer id="footer-section" className="footer-section clearfix">
          <div className="copyright-text2 text-center">
            <div className="container">
              <p className="mb-0">
                <i className="far fa-copyright"></i> Copyright By@{" "}
                <a
                  href="https://themeforest.net/user/marvel_theme/portfolio"
                  target={"_blank"}
                  rel="noopener noreferrer"
                  className="author-link"
                >
                  MarvelTheme
                </a>{" "}
                2021
              </p>
            </div>
          </div>
        </footer>
      </div>
    </Fragment>
  );
}

export default PreviewPage;
